<p-messages [showTransitionOptions]="'500ms'" [hideTransitionOptions]="'500ms'" [closable]="false" [escape]="false"
    [enableService]="false" [value]="messages" [styleClass]="styleClassCompleto">
</p-messages>